import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

import s from './Layout5.css';
import personajeCamaraIcon from '/public/SiteImages/personaje-camara.svg';

// Components
import SearchForm from '../SearchForm/SearchForm';

const Layout5 = ({ isLoading, title, homeBannerImages, content }) => {
  const [hideMenu, setHideMenu] = useState('');

  const handleScroll = useCallback(() => {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    const isWeb = window.matchMedia('(min-width: 1300px)').matches;
    setHideMenu(isWeb && top >= 410 ? 'hideMenu' : '');
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
      // Initial check
      handleScroll();
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
      }
    };
  }, [handleScroll]);

  let path = '/images/home/', homeBannerFirst
  const layout5Css = 'layout5Css';

  if (homeBannerImages && homeBannerImages.length > 0) homeBannerFirst = path + homeBannerImages[0].name;

  return (
    <div>
      <div className={cx(s.bannerLayoutContainer, 'layoutFive')}>
        <div className={cx(s.bannerBackgroundImage)}
          style={{ backgroundImage: `url(${homeBannerFirst})` }} />
        <div className={s.searchFormContainer}>
          <div className={s.logoAboveSearch}>
            <h1 className={cx(s.noMargin, s.bannerCaptionText, { [s.liquidglass]: !hideMenu })}>
              <span>{title}</span>
            </h1>
            <h3 className={cx(s.noMargin, s.bannerContentText, { [s.liquidglass]: !hideMenu })}>
              {' '} {content}
            </h3>
            {/* <img src={LogoSecundarioBlue} alt='' width={290} height={107} /> */}
          </div>
          <div className={s.searchRow}>
            <img src={personajeCamaraIcon} alt='' className={s.sideImage} />
            {/* <img src={PersonajeHome1} alt='' className={s.sideImage} /> */}
            <div className={cx(s.marginTop, hideMenu, s.searchMiddle)}>
              <SearchForm
                layout5Css={layout5Css}
                id={'layoutFive'}
                isLoading={isLoading}
                showPersonajeSearch={!hideMenu}
              />
            </div>
            {/* <img src={LookHome} alt='' className={s.sideImage} /> */}
            <div></div>
          </div>
          {/*  <div className={s.positionRelative}>
            <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
              <span>Reserva tu alojamiento en Bolivia</span> <img src={flagBol} alt='' width={51} height={51} />
            </h1>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default compose(withStyles(s))(Layout5);